// plugins/notification.ts

import { Plugin } from '@nuxt/types';

import { createClient } from 'graphql-ws';

const notificationPlugin: Plugin = (ctx) => {
  const { store } = ctx;

  store.watch(
    (storeState: any) => storeState.piano?.token,
    (token: string) => {
      if (token) {
        store.dispatch('notification/loadUnreadCount', { customerToken: token });

        const client = createClient({
          url: 'wss://notification.api.delfi.lt/notification/v2/subscriptions',
          lazy: true,
          retryAttempts: Infinity,
          connectionParams: () => {
            return token ? { Authorization: `Bearer ${token}` } : {};
          },
          on: {
            connected: () => console.info('[graphql-ws] Connected'),
            closed: (event: any) => console.warn('[graphql-ws] Closed', event.code, event.reason),
            error: (error) => console.error('[graphql-ws] Connection error', error),
          },
        });

        const unsubscribe = client.subscribe(
          {
            query: `
            subscription portal_root_notificationSubscription {
              notificationSubscription(input:{type:[WEB], event: [NOTIFICATION_PUBLISHED]}) {
                event
                notification {
                  id
                  status
                }
              }
            }
          `,
          },
          {
            next: ({ errors }) => {
              if (errors?.length) {
                console.error('[graphql-ws] Subscription errors', errors);

                return;
              }

              store.dispatch('notification/loadUnreadCount', { customerToken: token });
            },
            error: (error) => console.error('[graphql-ws] Subscription failed', error),
            complete: () => console.info('[graphql-ws] Subscription completed'),
          }
        );

        // Cleanup when the browser page is actually closed.
        window.addEventListener(
          'beforeunload',
          () => {
            unsubscribe();
            client.dispose();
          },
          { once: true }
        );
      }
    }
  );
};

export default notificationPlugin;
